import type { CarrierShipmentEvent } from '@/lib/api/carrier-shipment-api'

import { carrierEventLabel } from '@/lib/carrier-status'
import { formatDateTimeShort } from '@/lib/format'
import { m } from '@/lib/paraglide/messages'

interface Props {
    events: CarrierShipmentEvent[]
}

export function CarrierTrackingTimeline({ events }: Props) {
    const newestFirst = [...events].reverse()
    return (
        <div className="space-y-1">
            <p className="text-sm font-medium">{m.carrier_timeline_title()}</p>
            {newestFirst.length === 0 ? (
                <p className="text-muted-foreground text-sm">
                    {m.carrier_timeline_empty()}
                </p>
            ) : (
                <ol className="space-y-1">
                    {newestFirst.map((event) => (
                        <li
                            key={event.id}
                            data-testid="carrier-event"
                            className="border-border flex flex-wrap gap-x-2 border-l-2 pl-2 text-sm"
                        >
                            <span className="font-medium">
                                {carrierEventLabel(event.carrier_status_code)}
                            </span>
                            <span className="text-muted-foreground text-xs">
                                {formatDateTimeShort(event.event_at)}
                            </span>
                            {event.note && (
                                <span className="text-muted-foreground w-full text-xs">
                                    {event.note}
                                </span>
                            )}
                        </li>
                    ))}
                </ol>
            )}
        </div>
    )
}
